import { render, staticRenderFns } from "./basicOrderedTable.vue?vue&type=template&id=d6bb2530&scoped=true"
import script from "./basicOrderedTable.vue?vue&type=script&lang=js"
export * from "./basicOrderedTable.vue?vue&type=script&lang=js"
import style0 from "./basicOrderedTable.vue?vue&type=style&index=0&id=d6bb2530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bb2530",
  null
  
)

export default component.exports